import {EntityService} from '../../../../service/EntityService';

export class LicenseService extends EntityService {

  static entity = 'api/app/license';

}
